import React from 'react'
import { Controller, useFormContext, type Control, type FieldValues } from 'react-hook-form'
import { Checkbox, FormControlLabel, FormHelperText, FormControl, Box, Typography, type SxProps, type Theme } from '@mui/material'

interface FormCheckboxProps {
  name: string
  control?: Control<FieldValues>
  label?: string
  defaultValue?: boolean
  defaultChecked?: boolean
  checked?: boolean
  disabled?: boolean
  required?: boolean
  sx?: SxProps<Theme>
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  control,
  label,
  defaultValue = false,
  defaultChecked,
  checked,
  disabled = false,
  required = false,
  sx,
  onChange
}) => {
  const { control: contextControl } = useFormContext()

  return (
    <FormControl sx={sx} required={required}>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Controller
          name={name}
          control={control ?? contextControl}
          defaultValue={defaultValue}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={checked}
                  defaultChecked={defaultChecked}
                  disabled={disabled}
                  inputProps={{ 'aria-label': label }}
                  onChange={onChange}
                />
              }
              label={<Typography fontWeight={600}>{label}</Typography>}
              style={{
                margin: 0,
                paddingRight: 2
              }}
            />
          )}
        />
      </Box>
    </FormControl>
  )
}

export default FormCheckbox
